import { render, staticRenderFns } from "./PerfilEditDadosBasicos.vue?vue&type=template&id=027bb83c"
import script from "./PerfilEditDadosBasicos.vue?vue&type=script&lang=ts"
export * from "./PerfilEditDadosBasicos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports